
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Outstationtaxiservicepune() {



    const cardData =
    {
        keyword: 'Outstation Taxi Service Pune',
        heading: 'Platinum24 Cabs: Outstation Taxi Service Pune',
        headingDescription: ' Platinum24 Cabs provides reliable Outstation Taxi Service in Pune, perfect for family vacations, weekend getaways, corporate trips, and religious tours. Our diverse fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and comfortable ride on highways and hilly routes. With professional chauffeurs, punctual pickups, and flexible one-way or round-trip options, we make long-distance travel stress-free and convenient. Whether you’re heading to Mumbai, Shirdi, Mahabaleshwar, Goa, Nashik, or beyond, Platinum24 Cabs guarantees affordable fares, 24/7 availability, and a safe, enjoyable travel experience every time.',

        top: 'Top Places to Visit in Pune Outstation with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, 120 km from Pune, is a lush hill station famous for its viewpoints, strawberry farms, and cool weather. Venna Lake offers boating and horse rides, while Arthur’s Seat and Wilson Point provide panoramic valley views. Mapro Garden is known for fresh strawberry cream and fruit products. Monsoon adds mist, waterfalls, and greenery, making it even more magical. The Mahabaleshwar Temple adds spiritual significance. It is Pune’s most loved weekend hill getaway."
  },
  {
    "title": "Lonavala & Khandala",
    "description": "Just 65 km from Pune, Lonavala and Khandala are twin hill stations popular for their waterfalls, caves, and trekking spots. Bhushi Dam, Tiger’s Leap, and Karla Caves are the main attractions. Pawna Lake is famous for camping and stargazing. Lohagad and Rajmachi Fort offer both history and adventure. The region is also known for its sweet chikki. Lonavala–Khandala is Pune’s nearest and most vibrant escape."
  },
  {
    "title": "Shirdi",
    "description": "Located about 200 km from Pune, Shirdi is the holy town of Shri Sai Baba. Pilgrims visit the Samadhi Mandir, Dwarkamai, and Chavadi for darshan. Devotees attend aartis that create a divine atmosphere throughout the day. The town also has museums, heritage parks, and charitable institutions. Nearby Shani Shingnapur adds to the pilgrimage circuit. Shirdi is Pune’s most sacred outstation spiritual destination."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, around 110 km from Pune, is one of the 12 Jyotirlingas of Lord Shiva. Nestled in the Sahyadris, it is also a wildlife sanctuary home to the giant Indian squirrel. Trekkers love its misty forest trails and monsoon waterfalls. Gupt Bhimashankar and Hanuman Lake are peaceful spots nearby. Pilgrims flock here during Mahashivratri. Bhimashankar is Pune’s perfect blend of devotion and adventure."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, 60 km from Pune, is a planned hill city inspired by Italian architecture. Located on the banks of Warasgaon Lake, it offers boating, kayaking, and lakeside walks. Colorful buildings and waterfront promenades make it highly photogenic. Monsoon makes the town misty and romantic. Adventure sports and luxury resorts attract families and couples alike. Lavasa is Pune’s modern weekend retreat."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, about 140 km from Pune, is known as the ‘Goa of Maharashtra’ for its clean beaches and forts. Alibaug, Kashid, and Nagaon Beaches are popular for water sports and sunsets. Kolaba Fort and Kanakeshwar Temple add heritage value. Seafood and beachside resorts enhance the experience. Easily accessible by road, it’s ideal for families and groups. Alibaug is Pune’s nearest coastal paradise."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a spiritual and wine capital. It is home to Trimbakeshwar Jyotirlinga, Panchavati, and Ramkund along the Godavari River. The city also hosts the world-famous Kumbh Mela. Sula Vineyards offers wine tours, tastings, and festivals, attracting young travelers. Nashik blends religion, heritage, and leisure in one destination. It is Pune’s outstation mix of devotion and modernity."
  },
  {
    "title": "Kolhapur",
    "description": "Kolhapur, 230 km from Pune, is famous for the Mahalaxmi Temple, one of the Shakti Peethas. The city is also known for Rankala Lake, New Palace Museum, and Panhala Fort. Kolhapuri chappals, spicy cuisine, and jewelry make it a shopper’s delight. Pilgrims and history lovers visit year-round. It is also a hub of culture and tradition. Kolhapur is Pune’s cultural and spiritual getaway."
  },
  {
    "title": "Matheran",
    "description": "Matheran, 120 km from Pune, is India’s only automobile-free hill station. Visitors reach via toy train or horseback rides. Scenic points like Panorama Point, Echo Point, and Louisa Point offer breathtaking views. Red mud pathways and dense forests add rustic charm. Monsoon brings mist and waterfalls, making it enchanting. Matheran is Pune’s eco-friendly outstation retreat."
  },
  {
    "title": "Goa",
    "description": "Goa, 450 km from Pune, is India’s beach capital. It is famous for Baga, Calangute, and Anjuna beaches, buzzing nightlife, and flea markets. Old Goa’s churches like Basilica of Bom Jesus are UNESCO sites. Dudhsagar Waterfall and spice plantations add to its charm. Tourists enjoy water sports, parties, and peaceful retreats alike. Goa is Pune’s long-weekend paradise of fun, spirituality, and relaxation."
  }
],



     "services": [
    {
      "name": "Pune Outstation Taxi Service",
      "description": "Comprehensive outstation taxi services from Pune offering comfortable, safe, and reliable travel options to various destinations. Ideal for long-distance trips, family vacations, and business travel, these services ensure well-maintained vehicles and professional drivers for a smooth journey."
    },
    {
      "name": "Outstation Cab Booking Pune",
      "description": "Easy and quick outstation cab booking services in Pune, providing instant confirmation and multiple vehicle options. Whether planning a weekend getaway or a corporate trip, travelers can select cabs based on their budget and preferences with convenient online or phone booking."
    },
    {
      "name": "Pune Outstation Car Rental",
      "description": "Flexible car rental options for outstation travel from Pune with hourly, daily, or trip-based packages. Choose from a wide range of cars including hatchbacks, sedans, SUVs, and luxury vehicles to suit individual or group travel needs."
    },
    {
      "name": "Outstation Taxi Hire Pune",
      "description": "Affordable outstation taxi hire services from Pune with professional chauffeurs, well-maintained cars, and transparent pricing. Perfect for travelers looking for safe and convenient travel options beyond Pune city limits."
    },
    {
      "name": "Pune Outstation Taxi Rates",
      "description": "Competitive and transparent outstation taxi rates from Pune with detailed fare breakdowns including fuel charges, tolls, and driver allowances. Customers can request custom quotes based on their travel route, vehicle choice, and trip duration."
    },
    {
      "name": "Best Outstation Taxi Pune",
      "description": "Top-rated outstation taxi service providers in Pune known for punctuality, vehicle hygiene, and courteous drivers. Trusted by thousands of satisfied customers for seamless and comfortable long-distance journeys."
    },
    {
      "name": "Pune Outstation Taxi with Driver",
      "description": "Convenient outstation taxi rentals from Pune with experienced drivers who are knowledgeable about routes and ensure safe and comfortable rides. Drivers assist with luggage handling and provide local insights during the journey."
    },
    {
      "name": "Affordable Outstation Cabs Pune",
      "description": "Budget-friendly outstation cab services from Pune without compromising on quality and safety. Various cost-effective options are available for solo travelers, families, and groups seeking economical travel solutions."
    },
    {
      "name": "Outstation Taxi Packages Pune",
      "description": "Customized outstation taxi packages from Pune including round trips, multi-day rentals, and sightseeing options. Packages often cover fuel, tolls, driver allowances, and optional stops, providing excellent value for travelers."
    },
    {
      "name": "Pune to Mumbai Outstation Taxi",
      "description": "Dedicated taxi services from Pune to Mumbai for hassle-free travel to the metropolitan city. Options include one-way and round-trip bookings with flexible timings, ensuring timely airport transfers, business trips, or leisure visits."
    },
    {
      "name": "Pune to Goa Outstation Cab",
      "description": "Comfortable and reliable cab services from Pune to Goa for tourists and holidaymakers. Enjoy scenic drives in well-maintained vehicles with professional drivers who ensure safe journeys to this popular beach destination."
    },
    {
      "name": "Pune Outstation Taxi Online Booking",
      "description": "Convenient online booking platform for Pune outstation taxis allowing travelers to reserve cabs anytime, anywhere. Instant confirmation, multiple payment options, and customer support make travel planning easy and efficient."
    },
    {
      "name": "Reliable Outstation Taxi Pune",
      "description": "Trusted outstation taxi operators in Pune committed to providing dependable services with timely pickups, courteous drivers, and clean vehicles. Ensuring peace of mind for travelers embarking on long-distance trips."
    },
    {
      "name": "Pune Outstation Luxury Taxi",
      "description": "Premium luxury taxi services for outstation travel from Pune featuring high-end vehicles like SUVs, sedans, and luxury cars. Perfect for corporate clients, special occasions, or travelers seeking extra comfort and style."
    },
    {
      "name": "Pune Outstation Cab Service 24x7",
      "description": "Round-the-clock outstation cab services from Pune ensuring availability at all hours. Whether you have early morning flights, late-night travel, or urgent bookings, these services are ready to cater to your outstation travel needs anytime."
    }
  ],
  "tableData": [
    ["Pune Outstation Taxi Service", "Outstation Cab Booking Pune"],
    ["Pune Outstation Car Rental", "Outstation Taxi Hire Pune"],
    ["Pune Outstation Taxi Rates", "Best Outstation Taxi Pune"],
    ["Pune Outstation Taxi with Driver", "Affordable Outstation Cabs Pune"],
    ["Outstation Taxi Packages Pune", "Pune to Mumbai Outstation Taxi"],
    ["Pune to Goa Outstation Cab", "Pune Outstation Taxi Online Booking"],
    ["Reliable Outstation Taxi Pune", "Pune Outstation Luxury Taxi"],
    ["Pune Outstation Cab Service 24x7", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Outstation Taxi Service from Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable outstation taxi services from Pune to various destinations for a comfortable journey."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Safe and Smooth Travel",
      "WhyChoosedescription": "Our professional drivers are familiar with outstation routes to ensure your safety and timely arrival."
    },
    {
      "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
      "WhyChoosedescription": "Travel in clean, air-conditioned taxis equipped for long-distance comfort."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for stress-free travel."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages that best suit your travel plans and schedule."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available around the clock to assist you with bookings and queries."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicle Options to Match Your Needs",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and more based on your group size and comfort preferences."
    },
    {
      "WhyChooseheading": "Easy Online Booking and Real-Time Cab Tracking",
      "WhyChoosedescription": "Book your outstation taxi quickly and track your ride in real-time through our app or website."
    }
  ]





























    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer outstation taxi services from Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable outstation taxi services from Pune to various destinations.',
    },
    {
        question: 'How can I book an outstation taxi from Pune with Platinum24 Cabs?',
        answer: 'You can easily book your outstation taxi from Pune through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for outstation trips from Pune?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, tempo travellers, and premium cars to suit your travel preferences and group size.',
    },
    {
        question: 'Are the drivers experienced for long-distance outstation travel from Pune?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about outstation routes starting from Pune.',
    },
    {
        question: 'Can I book a round trip outstation taxi from Pune?',
        answer: 'Absolutely! We provide round-trip taxi services with flexible scheduling to suit your travel plans.',
    },
    {
        question: 'What is included in the fare for outstation taxi services from Pune?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for outstation trips from Pune?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points for outstation rides starting from Pune.',
    },
    {
        question: 'Are safety measures in place for outstation taxi rides from Pune?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire an outstation taxi for multiple days from Pune?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate outstation taxi services from Pune?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for outstation routes from Pune.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Kiran Joshi',
        feedback: 'The outstation taxi service from Pune by Platinum24 Cabs was punctual and very comfortable. The driver was professional.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Kulkarni',
        feedback: 'Booking an outstation taxi was hassle-free and the service exceeded my expectations. Highly recommended!',
        rating: 5,
    },
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];








const outstationTaxiServicePuneSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Outstation Taxi Service Pune",
  "image": "https://www.platinum24cab.com/assets/images/outstation-taxi-service-pune.jpg",
  "description": "Book trusted outstation taxi service from Pune with Platinum24 Cabs. Affordable and reliable cab options with AC cars, professional drivers, and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/outstation-taxi-service-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Outstation Taxi Service Pune | Book 24x7 Cab for Mumbai, Goa & More</title>
  <meta
    name="description"
    content="Book trusted outstation taxi service from Pune with Platinum24 Cabs. Affordable and reliable cab options with AC cars, professional drivers, and 24x7 availability."
  />
  <meta
    name="keywords"
    content="Pune Outstation Taxi Service, Outstation Cab Booking Pune, Pune Outstation Car Rental, Outstation Taxi Hire Pune, Pune Outstation Taxi Rates, Best Outstation Taxi Pune, Pune Outstation Taxi with Driver, Affordable Outstation Cabs Pune, Outstation Taxi Packages Pune, Pune to Mumbai Outstation Taxi, Pune to Goa Outstation Cab, Pune Outstation Taxi Online Booking, Reliable Outstation Taxi Pune, Pune Outstation Luxury Taxi, Pune Outstation Cab Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(outstationTaxiServicePuneSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Outstationtaxiservicepune;